import React, { useEffect } from 'react';
import { Button, Input, Table, Select, ContentsLayout, ContentsHeader } from 'src/components'
import styles from './User.module.scss';

/**
 * User コンポーネント
 * ユーザー情報の管理
 * @returns React.ReactNode
 */
const User: React.FC = () => {

  /**
   * GoogleAnalytics用トラッキング
   */
  useEffect(() => {
    window.gtag !== undefined && window.gtag('config', `${process.env.REACT_APP_DEV_TRACKING_ID}`, { page_path: window.location.pathname });
  }, []);

  return (
    <>
      <ContentsLayout>
        <ContentsHeader title="ユーザー管理">
          <Button>新規登録</Button>
        </ContentsHeader>
      </ContentsLayout>

      {/* <span>テナント</span>
        <Select>
        <option value="">すべてのテナント</option>
        </Select>

        <Table>
        <thead>
        <tr>
        <th>ユーザーID</th>
        <th>ユーザー名</th>
        <th>メールアドレス</th>
        <th>テナントID</th>
        <th>テナント名</th>
        <th>備考</th>
        <th>編集</th>
        </tr>
        </thead>
        <tbody>
        </tbody>
      </Table> */}
    </>
  );
};

export default User;